<template>
  <div class="user_info_form">
    <h4>사업자 정보​</h4>
    <p v-if="registerSelect == 2" class="description">
      개인사업자의 경우 대표자가 계정 신상과 동일한 경우만 가능합니다. ​
    </p>
    <p v-if="registerSelect == 3" class="description">사업자 정보를 입력해주세요​.</p>
    <dl class="business-name">
      <dt>업체(법인)명</dt>
      <dd class="form">
        <v-input v-model="businessInfo.businessName" target="businessName" @custom-input="updateBusinessInfo" />
      </dd>
    </dl>
    <dl class="business-number">
      <dt>사업자등록번호</dt>
      <dd class="form">
        <v-input-number
          v-model="businessInfo.businessLicenseNumber"
          @custom-input="updateBusinessInfo"
          placeholder="- 없이 숫자만 입력"
        />
      </dd>
    </dl>
    <dl class="userName">
      <dt>대표자명​</dt>
      <dd v-if="registerSelect == 2">{{ userInfo.userName }}</dd>
      <dd v-if="registerSelect == 3" class="form">
        <v-input v-model="businessInfo.businessOwnerName" @custom-input="updateBusinessInfo" />
      </dd>
    </dl>
    <address-form @update="updateAddress"></address-form>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import eventBus from '@/utils/eventBus';
import VInput from '@/components/atoms/VInput';
import VInputNumber from '@/components/atoms/VInputNumber';
import AddressForm from '@/components/modules/common/AddressForm';

export default {
  components: {
    VInput,
    VInputNumber,
    AddressForm,
  },
  data() {
    return {
      businessInfo: {},
      address: {},
    };
  },
  computed: {
    ...mapGetters('userInfo', ['userInfo', 'registerSelect']),
    isState() {
      return (
        !!this.businessInfo.businessName &&
        !!this.businessInfo.businessLicenseNumber &&
        (this.registerSelect == 2 ? true : !!this.businessInfo.businessOwnerName) &&
        this.address.isState
      );
    },
  },
  methods: {
    updateBusinessInfo() {
      this.$emit('update', {
        request: { ...this.address.request, ...this.businessInfo },
        isState: this.isState,
      });
      eventBus.$emit('businessInfoUpdate');
    },
    updateAddress(val) {
      this.address = val;
      this.updateBusinessInfo();
    },
  },
};
</script>
<style lang="scss"></style>
